import React, {useEffect, useState} from "react";
import ProgressiveBackgroundImg from "../ProgressiveBackgroundImg/ProgressiveBackgroundImg";
import ProgressiveGalleryImage from "../ProgressiveGalleryImage/ProgressiveGalleryImage";
import './projectGallery.css'
import { isMobile } from "../../globals/helpers";
import ProjGalleryGrid from "../ProjGalleryGrid/ProjGalleryGrid";
import ProjectStillsOrganiser from "../ProjectStillsOrganiser/ProjectStillsOrganiser";
import MobBoldQuote from "../mobBoldQuote/MobBoldQuote";
const ProjectGallery = ({data, isSecondaryView, scroller, isMobile, touchScrollerRef}) => {
    const [dynamicOdd, setDynamicOdd] = useState(false);
    const [dynamicRows, setDynamicRows] = useState(null);
    const [rowStyling, setRowStyling] = useState(null); 

    const [firstSection, setFirstSection] = useState(null);
    const [secondSection, setSecondSection] = useState(null);
    const [thirdSection, setThirdSection] = useState(null);

    const dynamicSources = data.stills.slice(1, data.stills.length - 2);

    useEffect(() => {
        setFirstSection({placeholder: data.stills[0].placeholder, src: data.stills[0].backgroundImage})
        setThirdSection({placeholder: data.stills[data.stills.length-1].placeholder, src: data.stills[data.stills.length-1].backgroundImage})
        if(dynamicSources.length == 1){
            setThirdSection({placeholder: dynamicSources[0].placeholder, src: dynamicSources[0].backgroundImage})
        } else{
            let rows = []
            for(let i=0; i<dynamicSources.length - 1; i+=2){
                let imgL = {placeholder: dynamicSources[i].placeholder, src: dynamicSources[i].backgroundImage}
                let imgR
                try{imgR = {placeholder: dynamicSources[i+1].placeholder, src: dynamicSources[i+1].backgroundImage}}
                catch{
                    rows.push([imgL])
                    break;
                }
                rows.push([imgL, imgR])
            }
            setSecondSection(rows);
        }
        
    }, [])

    return(
        <>
            {! isSecondaryView ? 
                <React.Fragment>
                    <ProjectStillsOrganiser
                        data={data}
                    />
                    <ProjGalleryGrid 
                        data={data}
                        scroller={scroller}
                        touchScrollerRef={touchScrollerRef}
                    />
                </React.Fragment>
                :
                <>
                    {
                        data.stills.map((item, idx) => (
                            <div className="mob_gallery_img__wrapper">
                                <ProgressiveGalleryImage
                                    src={item.backgroundImage}
                                    placeholderSrc={item.placeholder}
                                    idx={idx}
                                    scroller={scroller}
                                    startInvisible={true}
                                    isMobile={isMobile}
                                    overrideObserver={idx !== 0}
                                />
                            </div>
                        ))
                    }
                </>
            }
            
        </>
    )
}

export default ProjectGallery